document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeModule_FreeShippingProgress", () => {
    return {
      root: null,
      _morph(e) {
        const section = e.detail.response.sections["cart-free-shipping"];
        if (!section) return;
        const newEl = querySelectorInHTMLString(
          "[data-free-shipping-progress]",
          section,
        );
        if (newEl) {
          Alpine.morph(this.root, newEl.outerHTML);
        }
      },
      init() {
        this.root = this.$root;
        window.addEventListener("cascade:modalcart:afteradditem", (e) => {
          this._morph(e);
        });
        window.addEventListener("cascade:modalcart:cartqtychange", (e) => {
          this._morph(e);
        });
      },
    };
  });
});
